"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterShades = void 0;
var _filterData = require("./filterData");
const filterShades = shades => shades.filter(_filterData.filterData);
exports.filterShades = filterShades;
